import { FC, useState } from 'react';
import { VStack, Button, Text, Box, Flex } from '@chakra-ui/react';
import { useWeb3React } from 'hooks/web3';
import { Proposal } from 'types/snapshot';
import { useModal } from 'store/modals';
import NumberInput from './NumberInput';
import { ModalType } from 'components/modals/types';

type Props = {
  proposal: Proposal;
};

// TODO: Stop using as everywhere

const initState = (choices: string[]) => {
  const obj: { [key: string]: number } = {};
  choices.forEach((_, idx) => (obj[idx + 1] = 0));
  return obj;
};

const WeightedForm: FC<Props> = ({ proposal }) => {
  const { openModal } = useModal();
  const { choices } = proposal;
  const { account } = useWeb3React();
  const [amounts, setAmounts] = useState(initState(choices));

  const getPercent = (position: number) => {
    const regex = /\.00$/;
    const total = Object.values(amounts).reduce((a, b) => a + b);
    return total === 0
      ? 0
      : ((amounts[position]! / total) * 100).toFixed(1).replace(regex, '');
  };

  const handleSetAmounts = (key: string, amount: number) => {
    setAmounts((prevAmounts) => ({ ...prevAmounts, [key]: amount }));
  };

  const isNotSet = () => {
    return Object.values(amounts).every((x) => x === 0);
  };

  const handleVote = () => {
    openModal(ModalType.vote, {
      proposal,
      data: amounts
    });
  };

  return (
    <VStack alignItems='stretch' spacing={4}>
      {choices.map((choice, idx) => {
        return (
          <Box
            key={choice}
            borderWidth={1}
            borderRadius='xl'
            p={3}
            _hover={{ borderColor: 'white' }}
          >
            <Flex
              alignItems='center'
              px={[0, null, 3]}
              direction={['column', null, 'row']}
            >
              <Text flexGrow={1} width='100%' mb={[2, null, 0]}>{choice}</Text>
              <Flex
                alignItems='center'
                justifyContent='space-between'
                width={['100%', null, 'auto']}
              >
                <NumberInput setAmounts={handleSetAmounts} position={idx + 1} />
                <Text minW='60px' textAlign='right'>
                  {getPercent(idx + 1)}%
                </Text>
              </Flex>
            </Flex>
          </Box>
        );
      })}
      <Button
        size='lg'
        disabled={isNotSet() && !!account}
        onClick={
          !account ? () => openModal(ModalType.connectWallet) : handleVote
        }
      >
        {!account ? 'Connect Wallet' : 'Vote'}
      </Button>
    </VStack>
  );
};

export default WeightedForm;
